if (!customElements.get('deferred-app-section')) {
  customElements.define(
    'deferred-app-section',
    class DeferredAppSection extends HTMLElement {
      connectedCallback() {
        if (this.dataset.loaded === 'true') return;

        if (!('IntersectionObserver' in window)) {
          this.loadSection();
          return;
        }

        this.observer = new IntersectionObserver(
          (entries) => {
            if (!entries.some((entry) => entry.isIntersecting)) return;

            this.observer.disconnect();
            this.loadSection();
          },
          {
            rootMargin: '400px 0px',
          }
        );

        this.observer.observe(this);
      }

      disconnectedCallback() {
        this.observer?.disconnect();
      }

      async loadSection() {
        if (this.dataset.loaded === 'true' || this.dataset.loading === 'true') return;

        this.dataset.loading = 'true';

        try {
          const response = await fetch(this.dataset.sectionUrl, { credentials: 'same-origin' });
          if (!response.ok) throw new Error(`Failed to load section: ${response.status}`);

          const html = await response.text();
          const documentFragment = new DOMParser().parseFromString(html, 'text/html');
          const replacement = documentFragment.getElementById(this.id);

          if (!replacement) throw new Error(`Section ${this.id} was not found in the response.`);

          this.innerHTML = replacement.innerHTML;
          this.dataset.loaded = 'true';
          this.classList.remove('deferred-app-section--pending');
          this.activateScripts();
        } catch (error) {
          console.error('Deferred app section failed to load.', error);
        } finally {
          delete this.dataset.loading;
        }
      }

      activateScripts() {
        const scripts = this.querySelectorAll('script');

        scripts.forEach((oldScript) => {
          const newScript = document.createElement('script');

          for (const attribute of oldScript.attributes) {
            newScript.setAttribute(attribute.name, attribute.value);
          }

          newScript.textContent = oldScript.textContent;
          oldScript.replaceWith(newScript);
        });
      }
    }
  );
}
